<div fxLayout="column" fxLayoutAlign="start" class="full-screen">
  <app-header
    (go-back)="goToMain()"
    (show-selected-image-from-file)="showSelectedImageFromFile()"
    [title]="session.getToolName() + ' ' + session.getCurrentToolVersion()"
  ></app-header>
  <div class="wrapper">
    <!-- <h2 class="centerText" style="margin-bottom: 0;" *ngIf="session.getCurrentlySelectedImageFromFile().length === 1" i18n>Selected image:</h2>
    <h2 class="centerText" style="margin-bottom: 0;" *ngIf="session.getCurrentlySelectedImageFromFile().length > 1" i18n>Selected images:</h2> -->
    <!-- <span i18n *ngIf="session.getCurrentlySelectedImageFromFile().length === 1">The selected image</span>
      <span i18n *ngIf="session.getCurrentlySelectedImageFromFile().length > 1">The selected images</span> -->
      <figure>
        <div class="selectedImagesInfo">
          <div class="selectedImages">
          <img *ngFor="let img of session.getCurrentlySelectedImageFromFile()" [src]="img.base64.toString()">
        </div>
      </div>
    <figcaption *ngIf="session.getCurrentlySelectedImageFromFile().length === 1" i18n>Selected image</figcaption>
    <figcaption *ngIf="session.getCurrentlySelectedImageFromFile().length > 1" i18n>Selected images</figcaption>
        </figure>
    <h1 class="centerText" i18n>Search for a replacement image</h1>
    <div fxLayout="column" fxLayoutAlign="space-evenly stretch" class="form-wrapper">
      <form [formGroup]="searchFormGroup" (submit)="currentPage = 1; submitQuery()">
        <div class="searchOptions">
        <mat-form-field class="optionField">
          <mat-label i18n>Select Source</mat-label>
          <mat-select formControlName="targetApi" required (selectionChange)="currentPage = 1" multiple>
            <mat-option *ngFor="let api of externalImageSearchApis" [value]="api.key" >
              {{api.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="optionField">
          <mat-label i18n>Select License</mat-label>
          <mat-select formControlName="license" required multiple>
            <mat-option *ngFor="let license of licenses" [value]="license">
              {{licensesHumanReadable[license]}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
        <!-- <div fxLayout="row" fxLayoutAlign="space-around center"> -->
          <mat-form-field appearance="fill" class="primaryField">
            <mat-label i18n>Search query</mat-label>
            <input matInput formControlName="query" placeholder="keywords" [matAutocomplete]="classifiedSuggestions" #classifiedSuggestionTrigger="matAutocompleteTrigger" required/>
            <button style="align-self: center;"
            mat-icon-button
            matSuffix
            color="accent"
            type="button"
            (click)="getClientAutoImageResults()"
          >
            <mat-icon>auto_fix_high</mat-icon>
          </button>
          </mat-form-field>
          <mat-autocomplete #classifiedSuggestions="matAutocomplete" (optionSelected)="submitQuery()" >
            <mat-option *ngFor="let suggestion of querySuggestions" [value]="suggestion">
              {{suggestion}}
            </mat-option>
          </mat-autocomplete>
          <br />
          <button
            mat-raised-button
            matTooltip="Search for the given words"
            i18n-matTooltip
            matTooltipPosition="above"
            color="primary"
            [disabled]="!searchFormGroup.valid"
            type="submit"
            class="centerBiggerButton"
            i18n>
            Search
          </button>

          <!-- Removed the Auto button because the feature is not implemented and has bugs -->
          <!-- <button
            mat-raised-button
            matTooltip="Automatically recognize the image and search for suitable words"
            matTooltipPosition="above"
            color="accent"
            (click)="getAutoImageResults()"
            type="button"
          >
            Auto
          </button> -->
        <!-- </div> -->
      </form>

      <h2 class="centerText" *ngIf="showingResults" i18n>Choose a replacement image</h2>
      <div *ngIf="showPagination" class="pagination-wrapper">
        <button
          mat-raised-button
          matTooltip="Previous page of results"
          i18n-matTooltip
          matTooltipPosition="above"
          color="accent"
          id="left-paginator"
          [disabled]="currentPage === 1"
          (click)="currentPage = currentPage - 1; submitQuery();"
        ><mat-icon>arrow_back</mat-icon></button>
        <button
          mat-raised-button
          matTooltip="Next page of results"
          i18n-matTooltip
          matTooltipPosition="above"
          color="accent"
          id="right-paginator"
          [disabled]="!hasNextPage"
          (click)="currentPage = currentPage + 1; submitQuery()"
        ><mat-icon>arrow_forward</mat-icon></button>
      </div>
    </div>
    <div class="image-results-wrapper">
      <app-search-image-online-results [standardized-results]="searchStandardizedResultsSubject.asObservable()" (select)="onSelectedImage($event)" [clear-selection]="clearSelection$"></app-search-image-online-results>
    </div>
    <mat-spinner class="stillLoadingSpinner" *ngIf="showingResults && loadingResults"></mat-spinner>
    <div *ngIf="showPagination" class="pagination-wrapper">
      <button
      mat-raised-button
      matTooltip="Previous page of results"
      matTooltipPosition="above"
      color="accent"
      id="left-paginator"
      [disabled]="currentPage === 1"
      (click)="currentPage = currentPage - 1; submitQuery();"
      ><mat-icon>arrow_back</mat-icon></button>
      <button
      mat-raised-button
      matTooltip="Next page of results"
      matTooltipPosition="above"
      color="accent"
      id="right-paginator"
      [disabled]="!hasNextPage"
        (click)="currentPage = currentPage + 1; submitQuery()"
      ><mat-icon>arrow_forward</mat-icon></button>
    </div>
    <div *ngIf="showingResults" class="centerText searchYourselfDiv">
      <h4 i18n>Can't find anything fitting? Try searching yourself using google or duckduckgo:</h4>
    <h4><a target="_blank" rel="noreferrer" [href]="'https://www.google.com/search?q='+this.searchFormGroup.get('query').value+'&tbm=isch&safe=on&tbs=il:cl'" i18n>Related CC Images on Google</a> or <a target="_blank" rel="noreferrer" [href]="'https://duckduckgo.com/?q='+this.searchFormGroup.get('query').value+'&t=h_&iar=images&iaf=license%3AAny&iax=images&ia=images'" i18n>Related CC Images on DuckDuckGo</a> or 
      <a href="#" (click)="openDialogAITermsAndConditions($event)" i18n>Generate Images using AI</a></h4>
      <p>
        <span i18n>
          Please check the image results and licenses thoroughly yourself before using any of them.
        </span>
        <br />
        <span i18n>
          For the manual search, you will need to download the images yourself and then use the option 'Upload replacement from your machine' on the original image. There you can then enter the required information of the image you found.
        </span>
      </p>
    </div>
  </div>
</div>
